module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[20]141.b0f01d3.woff2";